import { createContext, useContext } from 'react';

import { PAGE_SIZE_DEFAULT } from 'bundles/unified-home-common/constants/MyLearningConstants';

export type PageSizeContextType = {
  pageSize: number;
  onPageSizeChange: (value: number) => void;
  currentPageNum: number;
  onPageChange: (value: number) => void;
};

const PageSizeContext = createContext<PageSizeContextType>({
  pageSize: PAGE_SIZE_DEFAULT,
  onPageSizeChange: () => undefined,
  onPageChange: () => undefined,
  currentPageNum: 1,
});

/**
 *
 * @description This hook is used to access the page size context.
 */
export const usePageSize = () => useContext(PageSizeContext);

export default PageSizeContext;
